import { Link } from "react-router-dom";
import { site } from "../../data/site";

export function Footer() {
  return (
    <footer className="site-footer">
      <div>
        <strong>{site.name}</strong>
        <p>{site.description}</p>
      </div>
      <nav aria-label="Footer navigation">
        <Link to="/">Home</Link>
        <Link to="/search">Search</Link>
        <Link to="/about">About</Link>
      </nav>
    </footer>
  );
}
